import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
  selector: 'app-autocomplete',
  imports: [AutoCompleteModule, FloatLabelModule],
  templateUrl: './autocomplete.component.html',
  styleUrl: './autocomplete.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AutoCompleteComponent {
  @Input() selectedValue: string = "";
  @Output() onSelect = new EventEmitter<any>();
  @Output() completeMethod = new EventEmitter<any>();
  @Input() inputlabel: string = '';
  @Input() suggestions!: any[];

  onSelectChange(event: any) {
    this.onSelect.emit(event);
  }

  onCompleteMethod(event: any) {
    this.completeMethod.emit(event);
  }
}
